import React, { useEffect, useMemo, useState, ReactNode } from "react";
import { observer } from "mobx-react";
import cn from "classnames";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { Tab, Tabs, Box } from "@mui/material";

import { IUserSettings } from "../type/type";

import { useStyles } from "./styles";

const DesktopUserSettings = ({
    tabSettingsContentList,
    value,
    onChange,
    appearanceTheme,
}: IUserSettings) => {
    const styles = useStyles();

    return (
        <TabContext value={value}>
            <Box
                className={cn(
                    styles.desktopUserSettingsWrapper,
                    appearanceTheme
                )}
            >
                <Tabs
                    className={cn(styles.tabs)}
                    value={value}
                    onChange={onChange}
                    variant="scrollable"
                >
                    {tabSettingsContentList.map((elem) => (
                        <Tab
                            key={elem.value}
                            className={cn(styles.tab)}
                            label={elem.label}
                            value={elem.value}
                            iconPosition="end"
                        />
                    ))}
                </Tabs>
                {tabSettingsContentList.map((elem) => (
                    <TabPanel
                        className={cn(
                            styles.desktopUserSettingsTabPanel,
                            appearanceTheme
                        )}
                        value={elem.value}
                        key={elem.value}
                    >
                        {elem.component}
                    </TabPanel>
                ))}
            </Box>
        </TabContext>
    );
};

export default observer(DesktopUserSettings);
